import React from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import CustomContainer from '../../components/CustomContainer';
import CardFormNew from '../../components/form/CardFormNew';
import LegalDocumentFormConfig from './LegalDocumentFormConfig';

const LegalDocumentPage = () => {
  const navigate = useNavigate();

  let { id } = useParams();

  return (
    <>
      <CustomContainer title={'Dokumenty prawne'}>
        <CardFormNew
          key={id}
          id={id}
          shadow={false}
          title={'Dokument'}
          api={'legal-document'}
          fields={LegalDocumentFormConfig}
          readOnly={!!id}
          postSaved={(saved) => {
            navigate(`/legal-document/${saved.id}`);
          }}
          width={6}
        />
      </CustomContainer>
    </>
  );
};

export default LegalDocumentPage;
